import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const MonitorsDisplaysCategoryMarketplaceIcon: React.FC<IStyledSVGIconProps> =
  (props) => {
    return (
      <StyledSVGIcon
        width="41"
        height="36"
        viewBox="0 0 41 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g>
          <path
            d="M36.75 0H4.75C2.55 0 0.75 1.8 0.75 4V26C0.75 28.2 2.55 30 4.75 30H10.75C9.65 31.1 8.75 31.74 8.75 33.18C8.75 34.74 10.01 36 11.57 36H29.91C31.47 36 32.73 34.74 32.73 33.18C32.73 31.74 31.85 31.12 30.73 30H36.73C38.93 30 40.73 28.2 40.73 26V4C40.75 1.8 38.95 0 36.75 0ZM36.75 26H4.75V4H36.75V26Z"
            fill="black"
            fill-opacity="0.54"
          />
        </g>
      </StyledSVGIcon>
    );
  };
